import { dateHourToBr } from '../util/date';
import maskCPFandCNPJ from '../util/maskCPFandCNPJ';
import { tipoDeEnvioOptions } from '../views/PosPagamento/Protocolo/Envio/constants';

const ID_APLICACAO_CLIENTE_POS_PAGAMENTO = 'C7E743C8-99FF-4DCB-83BA-D7ECA4C76DB5'

export const COLUMNS_POS_PARAM_ALTERAR_EMAIL = [
  {
    name: 'Descricao',
    title: 'Alerta',
  },
  {
    name: 'Email',
    title: 'E-mail',
  },
];

export const FIELDS_POS_PARAM_ALTERAR_EMAIL = [
  {
    name: 'idDadosAlertaKit',
    required: true,
    type: 'select',
    placeholder: 'Selecione um item',
    label: 'Alerta',
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: 'posPagamento/listar-options-kit?select=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

export const FIELDS_POS_PAG_CONSULTA = [
  {
    name: 'contrato',
    type: 'number',
    placeholder: 'Número do Contrato',
    label: 'Número do Contrato',
    maxLength: 10,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'cpfCnpj',
    type: 'input-cpfcnpj',
    placeholder: 'CPF ou CNPJ do Cliente',
    label: 'CPF ou CNPJ do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'nome',
    type: 'text',
    placeholder: 'Nome do Cliente',
    label: 'Nome do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'status',
    match_append_pos: 0,
    label: 'Status',
    type: 'select',
    placeholder: 'Selecione um item',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: `filtros/status?idApCliente=${ID_APLICACAO_CLIENTE_POS_PAGAMENTO}`,
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'dataFull',
    label: 'Período',
    required: true,
    fields: [
      {
        name: 'dataInicial',
        type: 'date',
        placeholder: '',
        label: 'Data Base - Início',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'dataFinal',
        type: 'date',
        placeholder: '',
        label: 'Data Base - Fim',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
]

export const FIELDS_ACOMPANHAR_SOLICITACAO = [
  {
    name: 'estado',
    type: 'select',
    placeholder: 'Selecione um Estado',
    label: 'Estado',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'cep/estados?formatado=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'credenciada',
    type: 'select',
    placeholder: 'Selecione uma Credenciada',
    label: 'Credenciada',
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: 'posPagamento/listar-credenciadas?formatado=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'status',
    type: 'select',
    placeholder: 'Selecione um Status',
    label: 'Status',
    options: [
      {
        text: 'Gerado',
        value: '2',
      },
      {
        text: 'Erro',
        value: '5, 199, 205, 251, 252',
      },
      {
        text: 'Pendente',
        value: '0, 1',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'dataSolicitacao',
    label: 'Data Solicitação',
    required: true,
    fields: [
      {
        name: 'dataInicial',
        label: 'Solicitação - Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinal',
        label: 'Solicitação - Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
];

export const COLUMNS_ACOMPANHAR_SOLICITACAO = [
  {
    name: 'Estado',
    title: 'Estado',
  },
  {
    name: 'Credenciada',
    title: 'Credenciada',
  },
  {
    name: 'Arquivo',
    title: 'Arquivo',
  },
  {
    name: 'Status',
    title: 'Status',
    type: 'custom',
  },
];

export const FIELDS_RELATORIOS_REGISTRO_CONTRATO_GERAL = [
  {
    type: 'dateRange',
    name: 'dataCriacao',
    label: 'Data Criação',
    required: true,
    fields: [
      {
        name: 'dataInicialContrato',
        label: 'Data Contrato - Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinalContrato',
        label: 'Data Contrato - Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
  {
    type: 'dateRange',
    name: 'envioKit',
    label: 'Envio Kit',
    required: true,
    fields: [
      {
        name: 'dataInicialKit',
        label: 'Solicitação de kit - Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinalKit',
        label: 'Solicitação de kit - Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
  {
    name: 'estado',
    type: 'select',
    placeholder: 'Selecione um Estado',
    label: 'Estado - UF',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'cep/estados?formatado=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'sucom',
    type: 'select',
    placeholder: 'Selecione um SUCOM',
    label: 'SUCOM',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/sucom',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'IdFila',
    type: 'select',
    placeholder: 'Selecione uma Fila',
    label: 'Fila',
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: 'posPagamento/listar-filas-pos-pagamento',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'status',
    type: 'select',
    placeholder: 'Selecione um Status',
    label: 'Status',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorioPosPag/statusDevolutivaKit',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

export const COLUMNS_REGISTRO_CONTRATO_GERAL = [
  {
    name: 'Contrato',
    title: 'Contrato',
  },
  {
    name: 'cpfCnpj',
    title: 'CPF/CNPJ',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  {
    name: 'uf',
    title: 'UF',
  },
  {
    name: 'CodGefin',
    title: 'Código GEFIN',
  },
  {
    name: 'solicitacaoKit',
    title: 'Solicitação Kit',
    dataFormat: (cell) => dateHourToBr(cell),
  },

  {
    name: 'Chassi',
    title: 'Chassi',
  },

  {
    name: 'credenciada',
    title: 'Credenciada',
  },
];

export const FIELDS_RELATORIO = [
  {
    name: 'relatorioPosPag',
    type: 'select',
    placeholder: 'Selecione um relatório',
    label: 'Relatório',
    required: true,
    options: [
      {
        text: 'Registro de Contrato - Faturamento',
        value: 'faturamento',
      },
      {
        text: 'Registro de Contrato - Geral',
        value: 'contratoGeral',
      },
      {
        text: 'Pós-Pagamento - Retirada de Original',
        value: 'retiradaDeOriginal',
      },
      {
        text: 'Pós-Pagamento - Protocolo',
        value: 'protocolo'
      },
      {
        text: 'Pós-Pagamento - Contratos Recepcionados',
        value: 'contratosRecepcionados'
      },
      {
        text: 'Processamento de Cargas',
        value: 'processamentoDeCargas'
      }
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

export const FIELDS_RELATORIO_FATURAMENTO = [
  {
    type: 'dateRange',
    name: 'dataSolicitacao',
    label: 'Data Solicitação',
    required: true,
    fields: [
      {
        name: 'dataInicialSolicitacao',
        label: 'Data Solicitação - Inicial',
        required: true,
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinalSolicitacao',
        label: 'Data Solicitação - Final',
        required: true,
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
  {
    name: 'uf',
    type: 'select',
    placeholder: 'Selecione um Estado',
    label: 'Estado',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'cep/estados?formatado=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'formatoEnvio',
    type: 'select',
    placeholder: 'Selecione',
    label: 'Formato de Envio',
    options: [
      {
        text: 'Unitário',
        value: 'Unitario',
      },
      {
        text: 'Lote',
        value: 'Lote',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'IdCredenciada',
    type: 'select',
    placeholder: 'Selecione uma Credenciada',
    label: 'Credenciada',
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: 'posPagamento/listar-credenciadas?formatado=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

export const COLUMNS_RELATORIO_FATURAMENTO = [
  {
    name: 'formatoEnvio',
    title: 'Formato de Envio',
  },
  {
    name: 'uf',
    title: 'UF',
  },
  {
    name: 'credenciada',
    title: 'Credenciada',
  },
  {
    name: 'qtdImagens',
    title: 'Qtd. de Imagens',
  },
  {
    name: 'DataEnvio',
    title: 'Data de Envio',
    dataFormat: (cell) => dateHourToBr(cell),
  },
  {
    name: 'imagensTratadas',
    title: 'Imagens Tratadas',
  },
];

export const FIELDS_RELATORIO_PROTOCOLO = [
  {
    name: 'protocoloRealizado',
    type: 'select',
    // placeholder: 'Selecione uma opção',
    label: 'Protocolo Realizado',
    required: true,
    options: [
      { text: "Selecione uma opção", value: "" },
      { text: "Sim", value: "protocoloRealizadoSim" },
      { text: "Não", value: "protocoloRealizadoNao" }
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  }
];

export const COLUMNS_RELATORIO_PROTOCOLO = [
  {
    name: 'NumeroContrato',
    title: 'Número Contrato',
  },
  {
    name: 'CPFCNPJ',
    title: 'CPF/CNPJ Cliente',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  {
    name: 'NomeCliente',
    title: 'Nome Cliente',
  },
  {
    name: 'codigoLoja',
    title: 'Loja',
  },
  {
    name: 'gefin',
    title: 'GEFIN',
  },
  {
    name: 'gecom',
    title: 'GECOM',
  },
  {
    name: 'sucom',
    title: 'SUCOM',
  },
  {
    name: 'database',
    title: 'Data Base'
  },
  {
    name: 'dataEnvioProtocolo',
    title: 'Data Protocolo'
  },
  {
    name: 'dataRecepcaoProtocolo',
    title: 'Data Recepção'
  },
];

export const FIELDS_RELATORIO_PROTOCOLO_REALIZADO_SIM = [
  {
    type: 'dateRange',
    name: 'dataProtocolo',
    label: 'Data Protocolo',
    required: true,
    fields: [
      {
        name: 'DataInicial',
        label: 'Data Protocolo - Inicial',
        sizeSm: 2,
        sizeMd: 3,
        required: true
      },
      {
        name: 'DataFinal',
        label: 'Data Protocolo - Final',
        sizeSm: 2,
        sizeMd: 3,
        required: true
      },
    ],
  },
  {
    name: 'tipoEnvioProtocolo',
    type: 'select',
    placeholder: 'Selecione',
    label: 'Tipo de Envio',
    options: tipoDeEnvioOptions,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'sucom',
    type: 'select-autocomplete',
    placeholder: 'Selecione',
    label: 'SUCOM',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/sucom',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  }
];

export const FIELDS_RELATORIO_PROTOCOLO_REALIZADO_NAO = [
  {
    type: 'dateRange',
    name: 'dataProtocolo',
    label: 'Data Base',
    required: true,
    fields: [
      {
        name: 'DataInicial',
        label: 'Data Base - Inicial',
        sizeSm: 2,
        sizeMd: 3,
        required: true
      },
      {
        name: 'DataFinal',
        label: 'Data Base - Final',
        sizeSm: 2,
        sizeMd: 3,
        required: true
      },
    ],
  },
  {
    name: 'sucom',
    type: 'select-autocomplete',
    placeholder: 'Selecione',
    label: 'SUCOM',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/sucom',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  }
];

export const FIELDS_RELATORIO_CONTRATOS_RECEPCIONADOS = [
  {
    type: 'dateRange',
    name: 'dataProtocolo',
    label: 'Data Recepção',
    required: true,
    fields: [
      {
        name: 'DataInicial',
        label: 'Data Recepção - Inicial',
        sizeSm: 2,
        sizeMd: 3,
        required: true
      },
      {
        name: 'DataFinal',
        label: 'Data Recepção - Final',
        sizeSm: 2,
        sizeMd: 3,
        required: true
      },
    ],
  },
  {
    name: 'sucom',
    type: 'select-autocomplete',
    placeholder: 'Selecione',
    label: 'SUCOM',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/sucom',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'segmento',
    type: 'select',
    placeholder: 'Selecione',
    label: 'Segmento',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: `/consulta/carteiras?idAplicacaoCliente=${ID_APLICACAO_CLIENTE_POS_PAGAMENTO}`,
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

export const COLUMNS_RELATORIO_CONTRATOS_RECEPCIONADOS = [
  {
    name: 'Contrato',
    title: 'Número Contrato',
  },
  {
    name: 'NomeCliente',
    title: 'Nome Cliente',
  },
  {
    name: 'CPFCNPJ',
    title: 'CPF/CNPJ Cliente',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  {
    name: 'dataRecepcao',
    title: 'Data Recepção'
  },
  {
    name: 'statusContrato',
    title: 'Status Contrato',
  },
  {
    name: 'sucom',
    title: 'SUCOM',
  },
  {
    name: 'carteira',
    title: 'Carteira',
  },
  {
    name: 'tipoEnvioProtocolo',
    title: 'Tipo Envio',
  },
];

export const FIELDS_RELATORIO_PROCESSAMENTO_CARGAS = [
  {
    type: 'dateRange',
    name: 'dataProtocolo',
    label: 'Data Processamento',
    required: true,
    fields: [
      {
        name: 'DataInicial',
        label: 'Data Processamento - Inicial',
        sizeSm: 2,
        sizeMd: 3,
        required: true
      },
      {
        name: 'DataFinal',
        label: 'Data Processamento - Final',
        sizeSm: 2,
        sizeMd: 3,
        required: true
      },
    ],
  },
]

export const COLUMNS_RELATORIO_PROCESSAMENTO_CARGAS = [
  {
    name: 'NomeCarga',
    title: 'Carga',
  },
  {
    name: 'DataProcessamento',
    title: 'Processamento Inicial'
  },
  {
    name: 'DataInclusao',
    title: 'Processamento Final'
  },
  {
    name: 'QtdLinhaProcessadas',
    title: 'Qtd. Linhas Processadas',
  },
  {
    name: 'QtdLinhaErros',
    title: 'Qtd. Linhas Erros',
  },
  {
    name: 'Observacao',
    title: 'Observação',
  },
];

export const FIELDS_POS_PAG_RETIRADA_DE_ORIGINAL = [
  {
    type: 'dateRange',
    name: 'dataSolicitacao',
    label: 'Data Solicitação',
    required: true,
    fields: [
      {
        name: 'DataInicial',
        label: 'Data Solicitação - Inicial',
        required: true,
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'DataFinal',
        label: 'Data Solicitação - Final',
        required: true,
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
  {
    name: 'usuario',
    type: 'text',
    placeholder: 'Funcional / CNPJ',
    label: 'Usuários',
    // remote: {
    //   method: 'GET',
    //   service: 'consulta',
    //   path: 'relatorio/usuarios',
    // },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'select',
    name: 'StatusSolicitacao',
    label: 'Status',
    placeholder: 'Selecione',
    options: [{
      text: 'Atendido',
      value: 'atendida'
    },

    {
      text: 'Aguardando',
      value: 'aguardando'
    },

    {
      text: 'Aprovação',
      value: 'aprovacao'
    },
    {
      text: 'Cancelado',
      value: 'cancelada'
    },
    {
      text: 'Aguardando Atendimento',
      value: 'aguardandoAtendimento'
    }]
  },

  {
    type: 'select',
    name: 'tipoEnvio',
    label: 'Tipo de Envio',
    placeholder: 'Selecione',
    options: [{
      text: 'Normal',
      value: '0'
    },

    {
      text: 'Urgente',
      value: '1'
    },
    ]
  }
];

export const COLUMNS_POS_PAG_RETIRADA_DE_ORIGINAL = [
  {
    name: 'NumeroContrato',
    title: 'Número Contrato',
    width: '140px',
  },
  {
    name: 'NumeroSolicitacao',
    title: 'Número Solicitação',
    width: '140px',
  },
  {
    name: 'DataSolicitacao',
    title: 'Data Solicitação',
    width: '140px',
  },
  {
    name: 'Solicitante',
    title: 'Solicitante',
    width: '140px',
  },
  {
    name: 'Status',
    title: 'Status',
    width: '140px',
  },
  {
    name: 'Devolvido',
    title: 'Devolvido',
    width: '140px',
  },
  {
    name: 'DocumentosDevolvidos',
    title: 'Doc. Devolvido',
    width: '140px',
  },
  {
    name: 'NumeroProtocolo',
    title: 'Número do Protocolo',
    width: '140px',
  },
  {
    name: 'Recepcionado',
    title: 'Recepcionado',
    width: '140px',
  },

];

export const COLUMNS_ANALITICO_POS = [
  {
    name: 'codGefin',
    title: 'Cód. GEFIN',
    width: '140px',
  },
  {
    name: 'nomeGefin',
    title: 'Nome do GEFIN',
    width: '140px',
  },
  {
    name: 'SUCOM',
    title: 'SUCOM',
    width: '140px',
  },
  {
    name: 'filial',
    title: 'Filial',
    width: '140px',
  },
  {
    name: 'dataSolicitacao',
    title: 'Data da Solicitação',
    width: '140px',
  },
  {
    name: 'dataGeracao',
    title: 'Data da Geração do Kit',
    width: '140px',
  },
  {
    name: 'statusGeracao',
    title: 'Status da Geração do Kit ',
    width: '140px',
  },
  {
    name: 'motivoErro',
    title: 'Motivo de Erro na Geração',
    width: '140px',
  },
  {
    name: 'dataEnvio',
    title: 'Data do Envio do Kit',
    width: '140px',
  },
  {
    name: 'statusKit',
    title: 'Status Atual do Kit',
    width: '140px',
  },
  {
    name: 'motivoRecusa',
    title: 'Motivo Recusa',
    width: '140px',
  },
  {
    name: 'validacaoDaRecusa',
    title: 'Validação da Recusa',
    width: '140px',
  },
  {
    name: 'codLoja',
    title: 'Cód. Loja',
    width: '140px',
  },
  {
    name: 'nomeLoja',
    title: 'Nome da Loja',
    width: '140px',
  },
  {
    name: 'numeroProposta',
    title: 'Número da Proposta',
    width: '140px',
  },
  {
    name: 'numeroContrato',
    title: 'Número do Contrato',
    width: '140px',
  },
  {
    name: 'dataBase',
    title: 'Data Base Contrato',
    width: '140px',
  },
  {
    name: 'nomeCliente',
    title: 'Nome Cliente',
    width: '140px',
  },
  {
    name: 'CPFCNPJ',
    title: 'CPF/ CNPJ',
    width: '140px',
  },
  {
    name: 'data',
    title: 'Data',
    width: '140px',
  },
  {
    name: 'chassi',
    title: 'Chassi',
    width: '140px',
  },
  {
    name: 'UF',
    title: 'Uf',
    width: '140px',
  },
  {
    name: 'credenciada',
    title: 'Credenciada',
    width: '140px',
  },
  {
    name: 'diversosBens',
    title: 'Diversos Bens',
    width: '140px',
  },
  {
    name: 'aditivo',
    title: 'Aditivo',
    width: '140px',
  },
  {
    name: 'renegociacao',
    title: 'Renegociação',
    width: '140px',
  },
  {
    name: 'filaAtual',
    title: 'Fila Atual',
    width: '140px',
  },
];

export const FIELDS_DASHBOARD = [
  {
    type: 'dateRange',
    name: 'dataSolicitacao',
    label: 'Data Solicitação',
    required: true,
    fields: [
      {
        name: 'dataInicial',
        label: 'Data Solicitação - Inicial',
        required: true,
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinal',
        label: 'Data Solicitação - Final',
        required: true,
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
];

export const FIELDS_ANALISE_DEVOLUTIVA = [
  {
    name: 'numeroProposta',
    type: 'number',
    placeholder: 'Número da Proposta',
    label: 'Número da Proposta',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'numeroContrato',
    type: 'number',
    placeholder: 'Número do Contrato',
    label: 'Número do Contrato',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'CPFCNPJ',
    type: 'input-cpfcnpj',
    placeholder: 'CPF ou CNPJ do Cliente',
    label: 'CPF ou CNPJ do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'nome',
    type: 'text',
    placeholder: 'Nome do Cliente',
    label: 'Nome do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'numeroChassi',
    type: 'text',
    placeholder: 'Número do Chassi',
    label: 'Número do Chassi',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'status',
    type: 'select',
    placeholder: 'Selecione um Status',
    label: 'Status',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'analiseDevolutiva/status',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'credenciada',
    type: 'select',
    placeholder: 'DETRAN/Credenciada',
    label: 'DETRAN/Credenciada',
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: 'posPagamento/listar-credenciadas?formatado=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'uf',
    type: 'select',
    placeholder: 'Selecione um Estado',
    label: 'Estado',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'cep/estados?formatado=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'dataRetorno',
    label: 'Data Retorno DETRAN',
    required: true,
    fields: [
      {
        name: 'dataInicial',
        label: 'Data Retorno DETRAN - Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinal',
        label: 'Data Retorno DETRAN - Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
];

export const COLUMNS_ANALISE_DEVOLUTIVA = [
  {
    name: 'numeroProposta',
    title: 'Proposta',
  },
  {
    name: 'nome',
    title: 'Nome do Cliente',
  },
  {
    name: 'CPFCNPJ',
    title: 'CPF/CNPJ do Cliente',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
  },
  {
    name: 'numeroContrato',
    title: 'Número Contrato',
  },
  {
    name: 'numeroChassi',
    title: 'Chassi',
  },
  {
    name: 'Status',
    title: 'Status',
  },
  {
    name: 'Credenciada',
    title: 'DETRAN/Credenciada',
  },
  {
    name: 'UF',
    title: 'UF',
  },
];

export const COLUMNS_ANALITICO_POS_CONTRATO_INEXISTENTE = [
  {
    name: 'Contrato',
    title: 'Contrato',
  },
  {
    name: 'Chassi',
    title: 'Chassi',
  },
  {
    name: 'Estado',
    title: 'Estado',
  },
  {
    name: 'Credenciada',
    title: 'Credenciada',
  },
  {
    name: 'DataSolicitacao',
    title: 'Data de Solicitação',
    /* dataFormat: (cell) => dateHourToBr(cell), */
  },
];

export const FIELDS_POS_PAG_SOLICITACAO_DOCUMENTOS = [
  {
    name: 'numeroContrato',
    type: 'number',
    placeholder: 'Número do Contrato',
    label: 'Número do Contrato',
    maxLength: 10,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'numeroSolicitacao',
    type: 'number',
    placeholder: 'Número Solicitação',
    label: 'Número Solicitação',
    maxLength: 10,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    type: 'dateRange',
    name: 'dataSolicitacao',
    label: 'Data Solicitação',
    required: true,
    fields: [
      {
        name: 'dataInicial',
        label: 'Data Solicitação - Inicial',
        sizeSm: 2,
        sizeMd: 3,
      },
      {
        name: 'dataFinal',
        label: 'Data Solicitação - Final',
        sizeSm: 2,
        sizeMd: 3,
      },
    ],
  },
  {
    name: 'statusSolicitacao',
    type: 'select',
    placeholder: 'Selecione um item',
    label: 'Status da Solicitação',
    options: [
      {
        text: 'Atendido',
        value: '5',
      },
      {
        text: 'Aguardando  Aprovação',
        value: '1',
      },
      {
        text: 'Cancelado',
        value: '8',
      },
      {
        text: 'Aguardando  Atendimento',
        value: '3',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
];

export const COLUMNS_POS_PAG_SOLICITACAO_DOCUMENTOS = [
  {
    name: 'Contrato',
    title: 'N° Contrato',
  },
  {
    name: 'NumeroSolicitacao',
    title: 'N° Solicitação',
  },
  {
    name: 'DataInclusao',
    title: 'Data Solicitação',
    dataFormat: (cell) => dateHourToBr(cell),
  },
  {
    name: 'Status',
    title: 'Status',
  },
  {
    name: 'Nome',
    title: 'Nome Solicitante',
  },
  {
    name: 'Login',
    title: 'Login Solicitante',
  },
  {
    name: 'Observacao',
    title: 'Motivo Cancelamento',
    width: '200px',
  },
  {
    name: 'DataAtendimento',
    title: 'Data Atendimento',
    dataFormat: (cell) => dateHourToBr(cell),
  },
  {
    name: 'TipoSolicitacao',
    title: 'Tipo de Solicitação',
  },
  {
    name: 'Prioridade',
    title: 'Prioridade ',
  }
];
export const FIELDS_POS_PAG_APROVADOR_SOLICITACAO = [
  {
    name: 'NumeroSolicitacao',
    type: 'number',
    placeholder: 'Nº Solicitação',
    label: 'Nº Solicitação',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'NumeroContrato',
    type: 'number',
    placeholder: 'Nº Contrato',
    label: 'Nº Contrato',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'CPFCNPJ',
    type: 'input-cpfcnpj',
    placeholder: 'CPF ou CNPJ do Cliente',
    label: 'CPF ou CNPJ do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  {
    name: 'NomeCliente',
    type: 'text',
    placeholder: 'Nome do Cliente',
    label: 'Nome do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
]

export const COLUMNS_POS_PAG_APROVADOR_SOLICITACAO = [
  {
    name: 'NumeroSolicitacao',
    title: 'Nº Solicitacao',
    width: '100px'
  },
  {
    name: 'CPFCNPJ',
    title: 'CPF/CNPJ do Cliente',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
    width: '140px'
  },
  {
    name: 'NomeCliente',
    title: 'Nome Cliente',
    width: '160px'
  },
  {
    name: 'DocSolicitado',
    title: 'Doc Solicitado',
    width: '240px'
  },
  {
    name: 'NomeSolicitante',
    title: 'Solicitante',
    width: '140px'
  },
]

export const FIELDS_POS_PAG_MONITOR_CONTRATOS = [
  {
    name: 'idSucom',
    type: 'select',
    placeholder: 'Selecione um SUCOM',
    label: 'SUCOM',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
  },
  {
    name: 'idGecom',
    type: 'select',
    placeholder: 'Selecione um GECOM',
    label: 'GECOM',
    options: [],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
  },
  {
    name: 'idGefin',
    type: 'select',
    placeholder: 'Selecione um GEFIN',
    label: 'GEFIN',
    options: [],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
  },
  {
    type: 'dateRange',
    name: 'dataBase',
    label: 'Data Base',
    fields: [
      {
        name: 'dataInicial',
        label: 'Data Base - Inicial',
        sizeSm: 2,
        sizeMd: 4,
      },
      {
        name: 'dataFinal',
        label: 'Data Base - Final',
        sizeSm: 2,
        sizeMd: 4,
      },
    ],
  },
]

const txtCenter = { textAlign: 'center' }

export const COLUMNS_POS_PAG_MONITOR_CONTRATOS = [
  {
    name: 'TemProtocolo',
    title: 'Sem Protocolo',
    type: 'custom',
    style: { backgroundColor: '#767171', ...txtCenter }
  },
  {
    name: 'AssinadoPrePagamento',
    title: 'Assinado Pré-Pagamento',
    type: 'custom',
    style: { backgroundColor: '#88E8A3', ...txtCenter }
  },
  {
    name: 'AAssinar',
    title: 'Á Assinar',
    type: 'custom',
    style: { backgroundColor: '#00BFFF', ...txtCenter }
  },
  {
    name: 'NaoAssinadoPrazo',
    title: 'Não Assinado no Prazo',
    type: 'custom',
    style: { backgroundColor: '#FFD700', ...txtCenter }
  },
  {
    name: 'AssinadoPosPag',
    title: 'Assinado Pós-Pagamento',
    type: 'custom',
    style: { backgroundColor: '#26CC55', ...txtCenter }
  },
  {
    name: 'AlteracaoNaoAssinada',
    title: 'Alteração Não Assinada',
    type: 'custom',
    style: { backgroundColor: '#FF0000', ...txtCenter }
  },
  {
    name: 'Pendentes',
    title: 'Pendentes',
    type: 'custom',
    style: { backgroundColor: '#767171', ...txtCenter }
  },
]